import {
    ACTUALIZAR_DISTRIBUCIONES,
    ACTUALIZAR_DISTRIBUCIONES_DB,
    CARGANDO_DIST,
    ERROR_DIST,
    LIMPIAR_ERROR
} from "./distribucionesActions";

const distribucionesReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_DISTRIBUCIONES:
        case ACTUALIZAR_DISTRIBUCIONES_DB: {
            return {
                ...state,
                distribuciones: action.payload,
                cargando: false,
                error: ""
            }
        }

        case CARGANDO_DIST: {
            return {
                ...state,
                cargando: true,
                error: ""
            }
        }

        case ERROR_DIST: {
            return {
                ...state,
                cargando: false,
                error: action.payload
            }
        }

        case LIMPIAR_ERROR: {
            return {
                ...state,
                error: ""
            }
        }

    }
}

export default distribucionesReducer;
